import React from 'react';
import { useIntl } from 'react-intl';
import SquareChip from '../chip/SquareChip';
import { isPlaceholderGeometrics } from './geometricsPlaceholder';
function isGeometricsRow(e) {
    return 'latitude' in e && 'longitude' in e;
}
/** Prefer newest timestamp among realtime rows (excluding Influx empty-window placeholders) and optional DB fallback. */
function latestWithField(realtimeMetrics, hasField, fallback) {
    const arr = realtimeMetrics?.filter((e) => hasField(e) &&
        (!isGeometricsRow(e) || !isPlaceholderGeometrics(e))) ?? [];
    const candidates = [...arr];
    if (fallback && hasField(fallback)) {
        candidates.push(fallback);
    }
    if (candidates.length === 0) {
        return undefined;
    }
    return candidates.reduce((a, b) => (a.time >= b.time ? a : b));
}
function StatusChip({ realtimeMetrics, lastMetrics, hasField }) {
    const intl = useIntl();
    const tailHas = (idx) => {
        const e = realtimeMetrics?.[idx];
        return !!e && hasField(e) && (!isGeometricsRow(e) || !isPlaceholderGeometrics(e));
    };
    if (realtimeMetrics && ((realtimeMetrics.length > 0 && tailHas(realtimeMetrics.length - 1)) || (realtimeMetrics.length > 1 && tailHas(realtimeMetrics.length - 2)))) {
        return React.createElement(SquareChip, { variant: "outlined", label: "Realtime", color: "warning" });
    }
    const lastRealtimeMetrics = latestWithField(realtimeMetrics, hasField, lastMetrics);
    if (!lastRealtimeMetrics) {
        return React.createElement(SquareChip, { variant: "outlined", label: "Updated at \u2014" });
    }
    const t = lastRealtimeMetrics.time;
    if (typeof t !== 'number' || !Number.isFinite(t) || t <= 0) {
        return React.createElement(SquareChip, { variant: "outlined", label: "Updated at \u2014" });
    }
    const updatedAt = intl.formatDate(t, { dateStyle: 'short', timeStyle: 'short' });
    return React.createElement(SquareChip, { variant: "outlined", label: `Updated at ${updatedAt}` });
}
export default React.memo(StatusChip);
